import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Card, CardContent, CircularProgress, Grid, Stack, TextField, Typography, Switch, FormControlLabel } from '@mui/material';
import { fetchPresidentById, updatePresident, uploadPresidentPhoto } from '../../controllers/presidentController';
import { resolvePresidentAssetUrl } from '../../api/httpClientPresidents';

const PresidentDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [item, setItem] = useState(null);
  const [saving, setSaving] = useState(false);
  const [file, setFile] = useState(null);

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await fetchPresidentById(id);
      setItem(data);
    } catch (e) {
      setError(e?.message || 'Kayıt alınamadı');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>;
  if (error) return <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>;
  if (!item) return null;

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Başkan Detayı</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Stack spacing={1} alignItems="center">
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', borderRadius: 1, overflow: 'hidden' }}>
                  {item.photoUrl ? (
                    <Box component="img" src={resolvePresidentAssetUrl(item.photoUrl)} alt={item.fullName} sx={{ maxWidth: '100%', maxHeight: 300, objectFit: 'contain' }} />
                  ) : (
                    <Box sx={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary' }}>Fotoğraf yok</Box>
                  )}
                </Box>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
                  <Button component="label" variant="outlined" size="small">
                    Fotoğraf Seç
                    <input hidden type="file" accept="image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
                  </Button>
                  <Button variant="contained" size="small" disabled={!file} onClick={async () => {
                    if (!file) return;
                    try {
                      await uploadPresidentPhoto({ pastPresidentId: item.id, file });
                      setFile(null);
                      await load();
                    } catch (e) {}
                  }}>Yükle</Button>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Stack spacing={1.25}>
                <TextField label="Ad Soyad" size="small" value={item.fullName} onChange={(e) => setItem({ ...item, fullName: e.target.value })} />
                <Stack direction="row" spacing={1}>
                  <TextField label="Başlangıç Yılı" size="small" type="number" value={item.termStartYear} onChange={(e) => setItem({ ...item, termStartYear: e.target.value ? parseInt(e.target.value, 10) : '' })} sx={{ flex: 1 }} />
                  <TextField label="Bitiş Yılı" size="small" type="number" value={item.termEndYear || ''} onChange={(e) => setItem({ ...item, termEndYear: e.target.value ? parseInt(e.target.value, 10) : null })} sx={{ flex: 1 }} />
                </Stack>
                <TextField label="Biyografi" size="small" value={item.biography || ''} onChange={(e) => setItem({ ...item, biography: e.target.value })} multiline minRows={4} />
                <FormControlLabel control={<Switch checked={!!item.isActive} onChange={(e) => setItem({ ...item, isActive: e.target.checked })} />} label="Aktif" />
                <Stack direction="row" spacing={1}>
                  <Button variant="contained" disabled={saving} onClick={async () => {
                    setSaving(true);
                    try {
                      await updatePresident({
                        id: item.id,
                        fullName: item.fullName,
                        termStartYear: item.termStartYear,
                        termEndYear: item.termEndYear,
                        biography: item.biography,
                        isActive: item.isActive,
                      });
                    } catch (e) {
                    } finally {
                      setSaving(false);
                      await load();
                    }
                  }}>Kaydet</Button>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PresidentDetail;



